import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/home/HomePage';
import SalesPage_pt from './pages/SalesPage_pt';
import BiblicalCrossword from './pages/BiblicalCrossword';
import LeadCaptureTestB from './pages/LeadCaptureTestB';
import ContactPage from './pages/ContactPage';
import PanicButtonStep1 from './pages/panic-button/PanicButtonStep1';
import PanicButtonIntro from './pages/panic-button/PanicButtonIntro';
import PanicButtonResult from './pages/panic-button/PanicButtonResult';
import PodcashAnxiety from './pages/PodcashAnxiety';

// /leads is the primary ad-landing entry point — lazy-loaded so its CSS/JS
// ships as its own chunk instead of bloating every other route's bundle.
const LeadCapture = lazy(() => import('./pages/LeadCapture'));

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/premium" element={<SalesPage_pt />} />
        <Route path="/crossword" element={<BiblicalCrossword />} />
        <Route
          path="/leads"
          element={
            <Suspense fallback={null}>
              <LeadCapture />
            </Suspense>
          }
        />
        <Route path="/leads-test-b" element={<LeadCaptureTestB />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/contato" element={<ContactPage />} />
        <Route path="/panic-button" element={<PanicButtonIntro />} />
        <Route path="/panic-button/step1" element={<PanicButtonStep1 />} />
        <Route path="/panic-button/result" element={<PanicButtonResult />} />
        <Route path="/podcash" element={<PodcashAnxiety />} />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
